import { render, staticRenderFns } from "./PreviewArts.vue?vue&type=template&id=1fa08d68&"
import script from "./PreviewArts.vue?vue&type=script&lang=js&"
export * from "./PreviewArts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports